export function DragDropPayloadDirective() {
    return {
        restrict: "A",
        require: "^^apexDragDropContainer",
        scope: {
            draggable: "<?",
            payloadModel: "<payloadModel", // The payload defined that will be transferred upon dropping.
            spillPayload: "&onSpillPayload", // Method to invoke when spilling a payload outside of a container.
            dragStart: "&onDragStart",
            dragEnd: "&onDragEnd"
        },
        link: function(scope, el, attrs, dragDropContainer) {
            // Draggable is optional, so set it true by default.
            scope.draggable = scope.draggable === undefined ? true : !!scope.draggable
            el[0].draggable = scope.draggable;
            el[0].addEventListener("dragstart", function(ev) {
                const data = JSON.stringify({
                    group: dragDropContainer.group,
                    payload: scope.payloadModel
                });
                ev.dataTransfer.setData("application/json", data);
                ev.dataTransfer.effectAllowed = scope.draggable ? "move" : "none";
                ev.dataTransfer.effectAllowed = scope.draggable ? "move" : "none";
                el[0].classList.add("dragdrop-dragging");
                scope.$apply(function() {
                    scope.dragStart({
                        $event: ev
                    });
                });
            });
            el[0].addEventListener("dragend", function(ev) {
                el[0].classList.remove("dragdrop-dragging");
                scope.$apply(function() {
                    scope.dragEnd({
                        $event: ev
                    });
                });
            });
            el[0].addEventListener("dragover", function(ev) {
                ev.preventDefault();
            })
        }
    }
}
